// services/faqService.ts
import axios from "axios";

import { CMS_KAFINTECH_API_URL } from "../../config/api";
import { PaginatedResponse } from "../../types/core/PaginatedResponse";
import { Faq, FaqToBackend } from "../../types/features/vitrine/Faq";

export const faqService = {
  // 🔓 PUBLIC - Pas de token nécessaire
  async getAll(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Faq>> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/faqs`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des FAQ", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire
  async getById(id: string): Promise<Faq> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/faqs/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de la FAQ", error);
      throw error;
    }
  },

  // ✅ NOUVEAU - Récupérer les FAQ par produit
  async getByProductName(
    productName: string,
    page: number = 1,
    perPage: number = 20,
    isVisible?: boolean
  ): Promise<PaginatedResponse<Faq>> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/faqs/product/${productName}`, {
        params: { 
          page, 
          per_page: perPage,
          is_visible: isVisible 
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des FAQ par produit", error);
      throw error;
    }
  },

  // ✅ NOUVEAU - Récupérer les FAQ visibles par produit
  async getVisibleByProductName(
    productName: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<Faq>> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/faqs/product/${productName}/visible`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des FAQ visibles par produit", error);
      throw error;
    }
  },

  // ✅ NOUVEAU - Récupérer les FAQ par produit et catégorie
  async getByProductAndCategory(
    productName: string,
    categoryId: string,
    page: number = 1,
    perPage: number = 20,
    isVisible?: boolean
  ): Promise<PaginatedResponse<Faq>> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/faqs/product/${productName}/category/${categoryId}`, {
        params: { 
          page, 
          per_page: perPage,
          is_visible: isVisible 
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des FAQ par catégorie", error);
      throw error;
    }
  },

  // ✅ NOUVEAU - Récupérer les FAQ par produit avec filtres
  async getByProductWithFilters(
    productName: string,
    filters: any = {},
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<Faq>> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/faqs/product/${productName}/filters`, {
        params: { 
          ...filters,
          page, 
          per_page: perPage 
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des FAQ avec filtres", error);
      throw error;
    }
  },


};